<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QH4LCR/images/cover.jpg?1699755110242" alt="This image is the cover for the book Siege Warfare During the Crusades"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Siege Warfare During the Crusades
      </h1>
      <p class="bookDescription body article font2">
        <b>An extensive study of the strategy and technology employed by the Franks and Muslims as they fought each other in the Holy Land.</b><br/><br/>Sieges played a key role in the crusades, but they tend to be overshadowed by the famous battles fought between the Franks and the Muslims, and no detailed study of the subject has been published in recent times. So, Michael Fulton’s graphic, wide-ranging, and thought-provoking book is a landmark in the field.<br/><br/>Fulton examines the history of siege warfare in the Holy Land from every angle—the tactics and technology, the fortifications, the composition of the opposing armies, and the ways in which sieges shaped Frankish and Muslim strategy at each stage of the conflict. The differences and similarities between the Eastern and Western traditions are explored, as is the impact of the shifting balance of power in the region.<br/><br/>The conclusions may surprise some readers. Neither the Muslims nor the Franks possessed a marked advantage in siege technology or tactics, their fortifications reflected different purposes and an evolving political environment, and, although there were improvements in technologies and fortifications, the essence of siege warfare remained relatively consistent.<br/><br/><b>Essential reading for medieval and military historians.</b><br/><br/><b>“A lavishly illustrated text full of original photographs of sites, many of which are inaccessible and hard to find images of, guides the reader through the strategies, tactics and weaponry of offense and defense in the Latin East.” —The Society for Medieval Archaeology</b><br/><br/><b>“This is a book you will read once and continually return to not only as an invaluable reference but as a cracking good read.” —Michael McCarthy, battlefield guide</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael S. Fulton
      </h2>
      
      <p class="authorDescription body article">Dr Michael S. Fulton is a medieval historian and archaeologist with a special interest in fortifications, siege warfare and the crusades. He is a visiting scholar with the History Department at the University of British Columbia. He has published many articles and papers on aspects of mechanical artillery, crusader castles, siege tactics and defences as well as the book Artillery in the Era of the Crusades.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword/Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7240bde7